/**
 * Iter53 P32 — ReworkBanner component extras din SaleDetail.js.
 *
 * Banner prominent afișat când `sale.requires_rework === true`. Vizibil pe orice tab.
 * Conține motivul + preview note BO + buton resolve (DOAR admin/backoffice).
 */
import { AlertTriangle, CheckCircle2 } from "lucide-react";
import { Button } from "../ui/button";

export default function ReworkBanner({ sale, canResolve, onResolveClick }) {
  if (!sale?.requires_rework) return null;
  return (
    <div
      className="rounded-lg border-l-4 border-amber-500 bg-amber-50 p-4 shadow-sm"
      data-testid="rework-banner"
    >
      <div className="flex flex-col md:flex-row md:items-start gap-3 md:gap-4">
        <div className="flex items-start gap-2 md:gap-3 min-w-0 flex-1">
          <AlertTriangle className="h-5 w-5 text-amber-600 shrink-0 mt-0.5" />
          <div className="min-w-0 flex-1">
            <p className="text-sm font-semibold text-amber-900">
              Vânzare în Rework
              {sale.problem_reason_code && (
                <span className="ml-2 inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-amber-200 text-amber-900">
                  {sale.problem_reason_code}
                </span>
              )}
            </p>
            <p className="mt-1 text-xs text-amber-800">
              Citește notele backoffice (tab Contract → secțiunea Note backoffice), rezolvă problema, apoi marchează rezolvat și retrimite spre reprocesare BO.
            </p>
            {sale.notes_bo && (
              <details className="mt-2 text-xs text-slate-700" data-testid="rework-banner-notes">
                <summary className="cursor-pointer font-medium text-amber-900">
                  Vezi note backoffice ({sale.notes_bo.length} caractere)
                </summary>
                <pre className="mt-1 max-h-32 overflow-y-auto whitespace-pre-wrap rounded bg-white border border-amber-200 p-2 text-[11px] font-sans text-slate-800">
                  {sale.notes_bo}
                </pre>
              </details>
            )}
          </div>
        </div>
        {canResolve && (
          <Button
            size="sm"
            onClick={onResolveClick}
            className="bg-emerald-600 hover:bg-emerald-700 text-white shrink-0"
            data-testid="rework-resolve-btn"
          >
            <CheckCircle2 className="h-4 w-4 mr-2" />
            Marchează rezolvat &amp; retrimite BO
          </Button>
        )}
      </div>
    </div>
  );
}
